<script setup>
import SearchField from 'shared/components/product/searchField.vue';
import AutoSuggest from 'shared/components/product/autoSuggest.vue';
import ProductListCardsSkeleton from 'shared/components/product/skeletons/productListCardsSkeleton.vue';
import useProductList from 'shared/components/product/composables/useProductList.js';
import useProductListLabels from 'shared/components/product/composables/useProductListLabels.js';

const productList = useProductList();

const { labels } = useProductListLabels();

</script>

<template>
	<search-field
		:isProductPage="true"
		:placeholder="labels.searchPlaceholderText.value"
		v-on:search="productList.handleSearch"
		v-on:reset="productList.resetSuggestions"
		v-on:autosuggestsearch="productList.autoSuggestSearch"
	>
		<ProductListCardsSkeleton
			v-if="productList.isSearching.value && productList.term.value"
			class="c-search__auto-suggest c-search__auto-suggest--product-page"
			:items="4"
			img-width="100"
			:separator="true"
		/>
		<auto-suggest
			v-else
			:is-product-page="true"
			:suggestions="productList.suggestions.value"
			:selected-index="productList.selectedSuggestionIndex.value"
			:property-group-delimiter="
				productList.suggestionPropertyGroupDelimiter.value
			"
			:ecommerce-tracking-data="
				productList.suggestionsEcommerceTrackingData.value
			"
			:tracking-enabled="true"
		>
		</auto-suggest>
	</search-field>
</template>
